import React, { useEffect, useState, useRef } from "react";
import { useReactMediaRecorder } from "react-media-recorder";
import audioWave from "../../../../assets/images/Images/Music-Wase.gif";
import { io } from "socket.io-client";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import ScrollToBottom from "react-scroll-to-bottom";
import PlayAudio from "react-simple-audio-player";
import chroma from "chroma-js";
import defultImage from "../../../../assets/images/Contact-Page.png";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import moment from "moment";
import useAudioHandleS3 from "../../../../CustomHooks/useAudioHandleS3";

const colorScale = chroma.scale(["#0199CB", "#ffffff"]).mode("lch").colors(5);

var NoImage =
  "https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8cGVyc29ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60";

function QnaMessageBody({ chatInfo, SendStatus, from }) {
  const { imageCdnUrl, serverUrl, shoketUrl, videoCdnUrl } =
    useContext(serverInfo);
  const [micPressStep, setMicPressStep] = useState(0);
  const [msgData, setMsgData] = useState([]);
  const [recordPlay, setRecordPlay] = useState(false);
  const [recordUrl, setRecordUrl] = useState(null);
  const [record, setRecord] = React.useState(false);
  const [text, setText] = useState("");
  const socket = useRef();
  const bottomRef = useRef(null);
  const [myRoom, setMyRoom] = useState(0);
  const [messageLoad, setMessageLoad] = useState(false);
  const [soundLoad, setSoundLoad] = useState(false);
  const { status, startRecording, stopRecording, mediaBlobUrl } =
    useReactMediaRecorder({ audio: true });

  const [audioUrl, audioKey, audioProgress, setFile, setDeleteFile] =
    useAudioHandleS3(null, "star/qna/voices", null);

  /**
   * socket connection
   */
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  useEffect(() => {
    setMsgData([]);
    if (chatInfo) {
      getMessageHistory();
    }
    socket.current.emit("leave-room", myRoom);
    socket.current.emit("join_room", chatInfo?.room_id);
    setMyRoom(chatInfo?.room_id);
    setText("");
  }, [chatInfo]);

  useEffect(() => {
    socket.current.on("qna_recive_message", (data) => {
      setMsgData((prv) => {
        return [...prv, data];
      });
    });
  }, [socket]);

  const getMessageHistory = () => {
    setMessageLoad(true);
    axios
      .get(`/api/mobile/qna-chat-history/${chatInfo?.room_id}`)
      .then((res) => {
        setMessageLoad(false);
        if (res.data.status === 200) {
          setMsgData(res.data.qna_history);
        }
      })
      .catch((err) => {});
  };

  /**
   * send to socket server
   */
  const HandelSentText = () => {
    let time =
      new Date(Date.now()).getHours() + ":" + new Date(Date.now()).getMinutes();
    let messageData = {
      sender_id: localStorage.getItem("auth_id"),
      room_id: chatInfo.room_id,
      sender_name: localStorage.getItem("auth_name"),
      sender_image: localStorage.getItem("auth_image"),
      qna_id: chatInfo.qna_id,
      msg_type: "text",
      media: null,
      text: text,
      time: time,
    };
    if (text.length > 0) {
      socket.current.emit("qna_send_message", messageData);
      setMsgData((prv) => {
        return [...prv, messageData];
      });
      setRecordUrl(null);
    }
    setText("");
  };

  useEffect(() => {
    if (mediaBlobUrl) {
      setRecordUrl(mediaBlobUrl);
    }
  }, [mediaBlobUrl]);

  useEffect(() => {
    if (record === false) {
      stopRecording();
    }
  }, [record]);

  const recordingStop = () => {
    stopRecording();
    setRecord(false);
    setMicPressStep(0);
  };

  /**
   * base64 convert
   */
  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  };

  /**
   * send info to socket server
   */
  const sendToSocket = (mediaUrl) => {
    setMicPressStep(0);
    let time =
      new Date(Date.now()).getHours() + ":" + new Date(Date.now()).getMinutes();
    // console.log({chatInfo});
    let messageData = {
      sender_id: chatInfo.qna?.star?.id,
      room_id: chatInfo.room_id,
      sender_name: chatInfo.qna?.star?.first_name,
      sender_image: chatInfo.qna?.star?.image,
      qna_id: chatInfo?.qna_id,
      msg_type: "audio",
      media: mediaUrl,
      text: text,
      time: time,
    };

    socket.current.emit("qna_send_message", messageData);
    setMsgData((prv) => {
      return [...prv, messageData];
    });
    setRecordUrl(null);
  };

  function handleMic() {
    setMicPressStep(micPressStep + 1);
    setRecord(!record);
    startRecording();
  }

  const handleSendAudioMsg = async () => {
    if (mediaBlobUrl) {
      const response = await fetch(mediaBlobUrl);
      const blob = await response.blob();
      const file = new File([blob], "audio.mp3", { type: "audio/mp3" });
      setFile(file);
    }
  };
  useEffect(() => {
    if (audioKey) {
      sendToSocket(audioKey);
    }
  }, [audioKey]);

  return (
    <>
      <div className="col-md-9">
        <div className="card message-right p-3 ms-3 ">
          <div
            className="d-flex align-items-center custom-relative-message "
            style={{
              backgroundColor: "#202C33",
              borderBottom: "0.5px solid gray",
              padding: 5,
            }}
          >
            {!chatInfo ? (
              <div
                style={{
                  height: "50px",
                  width: "50px",
                  backgroundColor: "#25272B",
                  borderRadius: 50,
                }}
              ></div>
            ) : (
              <img
                src={imageCdnUrl + chatInfo?.user.image}
                alt=""
                className="StarMessage me-2"
                height={50}
                width={50}
              />
            )}
            <div>
              {chatInfo && (
                <span className="text-light fw-bold">
                  {chatInfo?.user.first_name + " " + chatInfo?.user.last_name}
                </span>
              )}
              <div>
                <small className="text-warning">
                  {chatInfo?.user.user_type}
                </small>
              </div>
            </div>
          </div>
          <hr />
          <ScrollToBottom className="custom-text-message px-2">
            {messageLoad && (
              <div className="text-warning text-center my-2 mt-5">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}
            {!chatInfo && (
              <div
                className="text-warning text-center my-2 mt-5"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  src={defultImage}
                  height={200}
                  width={250}
                  style={{ opacity: 0.7, marginTop: "100px" }}
                />
                <p style={{ color: "#FFAD00" }}>Select user to see history</p>
              </div>
            )}
            <>
              {msgData &&
                msgData.map((item, index) => (
                  <div
                    className={
                      item.sender_id == chatInfo?.user.id
                        ? "d-flex my-3 w-75"
                        : "d-flex justify-content-end my-3 align-items-center second-person-message w-75 ms-auto"
                    }
                    key={index}
                  >
                    {item.sender_id == chatInfo?.user.id && (
                      <div>
                        <img
                          src={imageCdnUrl + item.sender_image}
                          alt=""
                          className="UserMessage me-2"
                        />
                      </div>
                    )}
                    <div
                      className={
                        item.sender_id == chatInfo?.user.id
                          ? "first-view-message rounded-3 p-2"
                          : "second-view-message  rounded-3 p-2"
                      }
                    >
                      {item.msg_type === "text" ? (
                        <span
                          style={
                            item.sender_id == chatInfo?.user.id
                              ? { color: "black" }
                              : { color: "#fff" }
                          }
                        >
                          {item?.text}
                        </span>
                      ) : (
                        <span>
                          <PlayAudio
                            url={videoCdnUrl + item.media}
                            colorScale={colorScale}
                            width={30}
                          />
                        </span>
                      )}
                      <small
                        className={`time-message d-flex justify-content-end  align-items-center ${
                          item.sender_id == chatInfo?.user.id
                            ? "text-secondary"
                            : "text-info"
                        }`}
                      >
                        {moment(item?.created_at)
                          .subtract(0, "days")
                          .calendar()}
                      </small>
                    </div>
                    {item.sender_id != chatInfo?.user.id && (
                      <div style={{ marginLeft: "10px" }}>
                        <img
                          src={imageCdnUrl + item.sender_image}
                          alt=""
                          className="UserMessage me-2"
                        />
                      </div>
                    )}
                  </div>
                ))}
            </>
          </ScrollToBottom>
          {from === "star" && (
            <>
              {!chatInfo ? (
                <div style={{ height: "80px" }}></div>
              ) : (
                <div className="d-flex align-items-center mt-3 justify-content-center flex-wrap bottom-message">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: record ? "center" : "center",
                      alignItems: "center"
                    }}
                  >
                    <>
                      {record && (
                        <>
                          <div
                            className="mic-btn-chat"
                            style={{
                              backgroundColor: "red",
                              marginLeft: "10px",
                            }}
                          >
                            <div
                              style={{
                                border: 0,
                                boxShadow: 0,
                                cursor: "pointer",
                              }}
                              className="btn border-0 bg-0 d-flex jusitiy-content-center align-items-center"
                              onClick={recordingStop}
                            >
                              <i
                                className={`fa-solid fa-trash`}
                                style={{ color: "white" }}
                              ></i>
                            </div>
                          </div>

                          <img
                            src={audioWave}
                            alt="recording"
                            className="w-50 img-fluid"
                          />
                        </>
                      )}

                      {soundLoad ? (
                        <div class="spinner-border text-warning" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <>
                          {micPressStep > 1 && (
                            <div
                              className="mic-btn-chat"
                              style={{
                                backgroundColor: "red",
                                marginLeft: "10px",
                              }}
                            >
                              <div
                                style={{
                                  border: 0,
                                  boxShadow: 0,
                                  cursor: "pointer",
                                }}
                                className="btn border-0 bg-0 d-flex jusitiy-content-center align-items-center"
                                onClick={recordingStop}
                              >
                                <i
                                  className={`fa-solid fa-trash`}
                                  style={{ color: "white" }}
                                ></i>
                              </div>
                            </div>
                          )}
                          {micPressStep > 1 && (
                            <span className="py-1 px-2">
                              <PlayAudio
                                url={mediaBlobUrl}
                                colorScale={colorScale}
                                width={50}
                                height={50}
                              />
                            </span>
                          )}
                          <div className="mic-btn-chat d-flex align-items-center justify-content-center">
                            <div
                              style={{
                                border: 0,
                                boxShadow: 0,
                                cursor: "pointer",
                              }}
                              className="btn border-0 bg-0 d-flex jusitiy-content-center align-items-center"
                              onClick={
                                micPressStep > 1
                                  ? handleSendAudioMsg
                                  : handleMic
                              }
                            >
                              {micPressStep > 1 ? (
                                <i className="fa-regular fa-paper-plane"></i>
                              ) : (
                                <i
                                  className={`fa-solid ${
                                    !record ? "fa-microphone" : "fa-check"
                                  } icon-message`}
                                  style={{
                                    color: `${record ? "red" : "white"}`,
                                  }}
                                ></i>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  </div>
                  {/* {record ? (
                    <div className="w-75 d-flex justify-content-end">
                      <div className="text-warning">
                        <img
                          src={audioWave}
                          alt="recording"
                          className="w-75 img-fluid"
                        />
                      </div>
                    </div>
                    ) : (
                      <></>
                    )} */}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default QnaMessageBody;
